/**
 * Copyright SimVentions, Inc. Usage, distribution, transferal, and licensing
 * of this source code is protected under SBIR law as described in DFARS 252.227-7018.
 *
 * SBIR data rights fully described in the README.md file in the top level directory of this project.
 */
export const Routes = {
  // TRANSFORM_ENGINE: "/Canvas",
  HOME: "/home",
  MAPPINGS: "/",
  JOBS: "/jobs",
  FILES: "/files",
  QUICKFORM: "/quickform",
  REFERENCE: "/reference",
  SETTINGS: "/settings",
  RESTRICTED: "/restricted",
} as const;

export type RouteValue = (typeof Routes)[keyof typeof Routes];
